import { PremiumPayFlagsEnum } from '../../../types';

export const isFlagContained = (
  flags: PremiumPayFlagsEnum[],
  flag: PremiumPayFlagsEnum
) => flags.includes(flag);
